export default {"src":"/_next/static/media/college4.8ae9410c.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};